import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, unref as _unref } from "vue"

const _hoisted_1 = { class: "dh-alert__text" }
const _hoisted_2 = { class: "dh-alert__fields" }
const _hoisted_3 = {
  key: 0,
  class: "dh-alert__code"
}
const _hoisted_4 = { class: "dh-alert__title" }
const _hoisted_5 = { class: "dh-alert__fields" }
const _hoisted_6 = { class: "dh-alert__code" }
const _hoisted_7 = { class: "dh-alert__fields" }
const _hoisted_8 = { class: "dh-alert__code" }

import { resolvePluginHostState } from '@front/plugins/resolve-plugin-host-state';
  import Spinner from '@front/components/Controls/Spinner.vue';
  import { ErrorBoundary } from '@front/shared/ErrorBoundary';
  import { getLoggerWithTag } from '@global/logger/v2/logger.mjs';
  import { pluginManager } from '@front/plugins/plugin-manager';
  import { computed, ref, watch } from 'vue';

  
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'PluginHost'
  },
  __name: 'PluginHost',
  props: {
    metadataError: {
      type: String,
      default: null
    },
    renderer: {
      type: [String, Object, Function],
      default: null
    },
    docType: {
      type: String,
      default: 'unknown'
    },
    isReloading: {
      type: Boolean,
      default: false
    },
    pluginsReady: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => ({})
    },
    profile: {
      type: Object,
      default: null
    },
    path: {
      type: String,
      default: ''
    },
    getContent: {
      type: Function,
      required: true
    },
    putEntities: {
      type: Function,
      required: true
    },
    putContent: {
      type: Function,
      required: true
    },
    toPrint: {
      type: Boolean,
      default: false
    },
    eventBus: {
      type: Object,
      required: true
    },
    pullData: {
      type: Function,
      required: true
    },
    contextMenu: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {

  const logger = getLoggerWithTag('f/c/D/PluginHost');

  

  // TODO: Типизировать через дженерик
  const props = __props;
  const errorBoundaryKey = ref(0);
  const pluginLoadError = ref<Error | null>(null);
  let loadRequestId = 0;

  const onRendererError = (
    error: unknown,
    _rendererInstance: unknown,
    info: string
  ): void => {
    logger.error(
      () => `Ошибка рендера документа типа [${props.docType}] `
        + `по пути [${props.path}], этап [${info}]`,
      error
    );
  };

  const availablePlugin = computed(() => {
    return pluginManager.getAvailablePluginByDocumentType(props.docType);
  });

  // Resolver определяет, что показывать: renderer, ожидание или ошибку.
  const hostState = computed(() => {
    return resolvePluginHostState({
      isReloading: props.isReloading,
      hasRenderer: Boolean(props.renderer),
      pluginsReady: props.pluginsReady,
      hasProfile: Boolean(props.profile),
      hasAvailablePlugin: Boolean(availablePlugin.value),
      hasMetadataError: Boolean(props.metadataError),
      hasPluginError: Boolean(pluginLoadError.value)
    });
  });

  const loadAvailablePlugin = async() => {
    const requestId = ++loadRequestId;

    pluginLoadError.value = null;

    if (
      props.isReloading
      || !props.pluginsReady
      || !props.profile
      || props.renderer
      || !availablePlugin.value
    ) {
      return;
    }

    const documentType = props.docType;

    try {
      await pluginManager.loadPluginByDocumentType(documentType);
    } catch (error: unknown) {
      if (requestId !== loadRequestId) return;

      pluginLoadError.value = error instanceof Error
        ? error
        : new Error(String(error));
    }
  };

  // Сбрасываем ошибку boundary при перерегистрации renderer
  // без размонтирования хоста.
  watch(() => props.renderer, () => {
    errorBoundaryKey.value++;
  });

  watch([
    () => props.docType,
    () => props.isReloading,
    () => props.pluginsReady,
    () => props.profile,
    () => props.renderer,
    availablePlugin
  ], loadAvailablePlugin, {
    immediate: true
  });

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (hostState.value === 'metadata-error')
    ? (_openBlock(), _createBlock(_component_v_alert, {
        key: 0,
        class: "dh-alert dh-alert--error",
        icon: "mdi-alert-circle-outline"
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "dh-alert__title" }, "Не удалось загрузить сведения о плагинах", -1)),
          _createElementVNode("div", _hoisted_1, _toDisplayString(__props.metadataError), 1)
        ]),
        _: 1
      }))
    : (hostState.value === 'loading')
      ? (_openBlock(), _createBlock(Spinner, { key: 1 }))
      : (hostState.value === 'plugin-error')
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 2,
            class: "dh-alert dh-alert--error",
            icon: "mdi-alert-circle-outline"
          }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dh-alert__title" }, "Ошибка загрузки плагина", -1)),
              _createElementVNode("dl", _hoisted_2, [
                _cache[1] || (_cache[1] = _createElementVNode("dt", null, "Тип документа", -1)),
                _createElementVNode("dd", null, _toDisplayString(__props.docType), 1),
                _cache[2] || (_cache[2] = _createElementVNode("dt", null, "Расположение", -1)),
                _createElementVNode("dd", null, _toDisplayString(__props.path), 1)
              ]),
              (pluginLoadError.value?.message)
                ? (_openBlock(), _createElementBlock("pre", _hoisted_3, _toDisplayString(pluginLoadError.value.message), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : (hostState.value === 'unknown')
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 3,
              class: "dh-alert dh-alert--warning",
              icon: "mdi-alert-outline"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, "Неизвестный тип документа [" + _toDisplayString(__props.docType) + "]", 1),
                _createElementVNode("dl", _hoisted_5, [
                  _cache[4] || (_cache[4] = _createElementVNode("dt", null, "Расположение", -1)),
                  _createElementVNode("dd", null, _toDisplayString(__props.path), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("dt", null, "Параметры", -1)),
                  _createElementVNode("dd", null, _toDisplayString(JSON.stringify(__props.params)), 1)
                ]),
                _createElementVNode("pre", _hoisted_6, _toDisplayString(JSON.stringify(__props.profile, null, 2)), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(ErrorBoundary), {
              key: errorBoundaryKey.value,
              "on-error": onRendererError,
              tag: "div",
              "stop-propagation": ""
            }, {
              boundary: _withCtx(({ hasError, err, info }) => [
                hasError
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      class: "dh-alert dh-alert--error",
                      icon: "mdi-alert-circle-outline"
                    }, {
                      default: _withCtx(() => [
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "dh-alert__title" }, "Ошибка рендера документа", -1)),
                        _createElementVNode("dl", _hoisted_7, [
                          _cache[6] || (_cache[6] = _createElementVNode("dt", null, "Тип документа", -1)),
                          _createElementVNode("dd", null, _toDisplayString(__props.docType), 1),
                          _cache[7] || (_cache[7] = _createElementVNode("dt", null, "Расположение", -1)),
                          _createElementVNode("dd", null, _toDisplayString(__props.path), 1),
                          _cache[8] || (_cache[8] = _createElementVNode("dt", null, "Этап", -1)),
                          _createElementVNode("dd", null, _toDisplayString(info), 1)
                        ]),
                        _createElementVNode("pre", _hoisted_8, _toDisplayString(err?.message || err), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createBlock(_resolveDynamicComponent(__props.renderer), {
                      key: 1,
                      inline: __props.inline,
                      params: __props.params,
                      profile: __props.profile,
                      path: __props.path,
                      "get-content": __props.getContent,
                      "put-entities": __props.putEntities,
                      "put-content": __props.putContent,
                      "to-print": __props.toPrint,
                      "event-bus": __props.eventBus,
                      "pull-data": __props.pullData,
                      "context-menu": __props.contextMenu
                    }, null, 8, ["inline", "params", "profile", "path", "get-content", "put-entities", "put-content", "to-print", "event-bus", "pull-data", "context-menu"]))
              ]),
              _: 1
            }))
}
}

})